import dayjs from 'dayjs';
import 'dayjs/locale/sv';

// Swedish counterpart of the global 'custom' dayjs locale registered by the job ad
// list items: relative time without the "ago" part ("2 dagar" instead of "för 2 dagar sedan").
// Registered locally so it doesn't replace the global locale.
dayjs.locale('sv-short', {
  ...dayjs.Ls.sv,
  name: 'sv-short',
  relativeTime: { ...dayjs.Ls.sv.relativeTime, future: 'om %s', past: '%s' },
}, true);

// Returns a dayjs instance localized for the given i18n language, or the
// instance untouched for English so the global locale keeps applying.
export const localizeRelativeTime = (date, lng) => (lng?.startsWith('sv') ? date.locale('sv-short') : date);
